import { Button, Icon, Popover } from '@economic/taco';
import { t, Trans } from '@lingui/macro';
import React from 'react';

export enum FormType {
    CreateAndNew = 0,
    Edit,
    Copy,
    Save,
    EditAndNext,
    SaveAndNew,
}

interface Shortcut {
    key: string;
    actionDescription: string;
}

export function ShortcutsPopover({ formType }: { formType: FormType }) {
    const shortcuts: Shortcut[] = [];
    switch (formType) {
        case FormType.CreateAndNew:
            shortcuts.push({ key: t`Enter/Return`, actionDescription: t`Save & new` });
            break;
        case FormType.Save:
            shortcuts.push({ key: t`Enter/Return`, actionDescription: t`Save` });
            break;
        case FormType.Edit:
            shortcuts.push({ key: t`Ctrl + Down arrow`, actionDescription: t`Save & next` });
            shortcuts.push({ key: t`Ctrl + Up arrow`, actionDescription: t`Save & previous` });
            shortcuts.push({ key: t`Enter/Return`, actionDescription: t`Save` });
            break;
        case FormType.EditAndNext:
            shortcuts.push({ key: t`Ctrl + Down arrow`, actionDescription: t`Save & next` });
            shortcuts.push({ key: t`Ctrl + Up arrow`, actionDescription: t`Save & previous` });
            shortcuts.push({ key: t`Enter/Return`, actionDescription: t`Save & next` });
            break;
        case FormType.Copy:
            shortcuts.push({ key: t`Enter/Return`, actionDescription: t`Save` });
            break;
        case FormType.SaveAndNew:
            shortcuts.push({ key: t`Ctrl + Down arrow`, actionDescription: t`Save & next` });
            shortcuts.push({ key: t`Ctrl + Up arrow`, actionDescription: t`Save & previous` });
            shortcuts.push({ key: t`Enter/Return`, actionDescription: t`Save & new` });
            break;
    }
    shortcuts.push({ key: t`Esc`, actionDescription: t`Close window` });

    return (
        <Popover>
            <Popover.Trigger>
                <Button appearance="discrete">
                    <Trans>Shortcuts</Trans>
                    &nbsp;
                    <Icon name="shortcuts" />
                </Button>
            </Popover.Trigger>
            <Popover.Content aria-label={t`Keyboard shortcuts`}>
                <h3>Keyboard shortcuts</h3>
                <div className="w-56 mt-4">
                    <dl>
                        {shortcuts.map((shortcut, idx) => (
                            <div key={idx} className="w-full flex justify-between mb-2">
                                <dt>{shortcut.key}</dt>
                                <dd className="mb-0">{shortcut.actionDescription}</dd>
                            </div>
                        ))}
                    </dl>

                    <Popover.Close>
                        <Button appearance="default">
                            <Trans>Close</Trans>
                        </Button>
                    </Popover.Close>
                </div>
            </Popover.Content>
        </Popover>
    );
}
